<template>
	<div>
		<div class="container">
			<Menu :openKey="'6'" :name="'通知公告'"></Menu>
			<div class="content">
				<a-breadcrumb class="nav" :routes="routes">
					<template slot="itemRender" slot-scope="{ route, routes }">
						<span class="active" v-if="routes.indexOf(route) === routes.length - 1">
							{{ route.breadcrumbName }}
						</span>
						<router-link v-else :to="`${basePath}/${route.path}`">
							{{ route.breadcrumbName }}
						</router-link>
					</template>
				</a-breadcrumb>
				<div style="margin-top: 20px">
					<div v-if="isRouter">
						<Article :isnotice="true" v-for="item in data.records" :key="item.noticeId" :data="item" @success="success(item)"></Article>
						<a-row>
							<a-col span="12" offset="6" style="text-align: center; padding: 20px 0">
								<a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext" @showSizeChange="setLimit" :current="data.current" />
							</a-col>
						</a-row>
					</div>
					<router-view style="margin-top: 20px" v-if="!isRouter"></router-view>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
// import articleVue from '../components/article.vue';
import Menu from '../components/menu.vue';
import Article from '../components/article.vue';
import utils from '@/common/utils';
export default {
	components: { Menu, Article },
	data() {
		return {
			isRouter: true,
			data: {},
			param: {
				current: 1,
				limit: 10,
				keyword: ''
			},
			basePath: '/index',
			routes: [
				{
					path: 'home',
					breadcrumbName: '首页'
				},
				{
					path: 'notice',
					breadcrumbName: '通知公告'
				}
			]
		};
	},
	created() {
		this.$watch('$route', (to, from) => {
			if (to.path) {
				this.isRouter = true;
				if (to.path == '/index/notice') {
					this.routes.pop();
				}
			}
		});
	},
	mounted() {
		this.$nextTick(() => {
			this.getList();
		});
		if (this.$route.path == '/index/notice/detail') {
			this.isRouter = false;
			this.routes.push({
				path: 'notice/detail',
				breadcrumbName: this.$route.query.title
			});
		}
	},
	methods: {
		getList() {
			utils.showSpin();
			this.http.get('/api/common/notice', this.param).then(ret => {
				utils.closeSpin();
				this.data = ret.data;
			});
		},
		//设置每页的显示条数
		setLimit(current, limit) {
			this.param.page = 1;
			this.param.limit = limit;
			this.getList;
		},
		//页码切换
		getNext(page) {
			this.param.page = page;
			this.getList();
		},
		async success(item) {
			await this.$router.push({
				path: '/index/notice/detail',
				query: {
					id: item.noticeId
				}
			});
			this.isRouter = false;
			this.routes.push({
				path: 'notice/detail',
				breadcrumbName: item.title
			});
		}
	}
};
</script>
<style scoped>
.container {
	width: 80%;
	min-width: 598px;
	margin: 0 auto;
	margin-top: 40px;
	display: flex;
}
.ant-breadcrumb a:hover {
	color: #e96432 !important;
}
.content {
	flex: 1;
	margin-left: 80px;
	height: 40px;
	background: #f7f7f7;
}
.nav {
	margin-top: 10px;
	margin-left: 10px;
}
.active {
	color: #e96432 !important;
}

.nav .ant-breadcrumb-link {
	color: #e96432;
}
.ant-breadcrumb {
	color: #e96432;
}
</style>
